<template>
  <div class="bg-green-80">
    <div class="p-16">
      <BlTextAv weight="bold" variation="body-16" tag="h2" color="inverse">Kelas-kelas pilihan</BlTextAv>
    </div>

    <div class="space-y-2 pb-28">
      <div
        v-for="(courses, i) in displayableCourses"
        :key="`scrollable-${i}`"
        class="courses-group ph-16 flex scroll-pl-4 space-x-2 overflow-x-auto snap-x"
      >
        <div v-for="course in courses" :key="course.id" class="snap-start w-[148px] shrink-0">
          <CardItem
            :course="serializeItemToCourse(course)"
            class="min-w-[148px]"
            referrer="edu_karier_greenbox"
            section-name="edu_karier_greenbox"
            is-hide-border
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardItem from '../CardItem/CardItem.vue';
import {mapActions, mapGetters} from 'vuex';
import {BlTextAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'BestCourses',
  components: {BlTextAv, CardItem},
  computed: {
    ...mapGetters('courses', ['getBestCourses']),
    displayableCourses() {
      return this.getBestCourses.reduce(
        ([even, odd], item, index) => (index % 2 === 0 ? [[...even, item], odd] : [even, [...odd, item]]),
        [[], []]
      );
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions('courses', ['fetchBestCourses']),
    init() {
      this.fetchBestCourses();
    },
    serializeItemToCourse(item) {
      return {
        id: item.item_id,
        name: item.item_name,
        images: [{url: item.image_url}],
        discount: {original_price: item.original_price},
        rating: item.rating,
        course_type: item.course_type || '',
        merchant_name: item.merchant_name,
      };
    },
  },
};
</script>
